<template>
  <div>
    <Map></Map>
  </div>
</template>

<script>
/* eslint-disable */
import Map from '../../../components/Map/Map'


export default {
  components: { Map }
}
</script>

